export default __webpack_public_path__ + "static/media/3037.e8b41ff1.jpg";